import React from 'react';
import styled from 'styled-components';

const FooterMargin = styled.div`
  margin-top: 20px;
`;

interface Props {
  children: any;
  isRakutenCoJpDomain: boolean;
}

export const Footer = (props: Props) => {
  return (
    <FooterMargin>
      <div
        dangerouslySetInnerHTML={{
          __html: props.children,
        }}
      />
    </FooterMargin>
  );
};
